import classes from './Room.module.css';
import logo from "../../../store/Diplomat/logo02.png"
import {Fragment, useEffect, useState} from "react";
import defScreen from "../../../store/thumbnail_image004.png"
import axios from "axios";
import { path, assetsBaseUrl } from "../../../routes";

// Parse meeting date strictly as LOCAL time (no timezone conversion)
const parseLocalDateTime = (value) => {
    if (!value) return NaN;
    const s = String(value).trim();
    if (!s) return NaN;
    let clean = s
        .replace('T', ' ')
        .replace(/\.\d+$/, '')
        .replace(/[+-]\d{2}:?\d{2}$/, '')
        .replace(/Z$/, '');
    const [datePart, timePart] = clean.split(' ');
    if (!datePart || !timePart) return NaN;
    const [yStr, mStr, dStr] = datePart.split('-');
    const [hStr, minStr, secStr] = timePart.split(':');
    const y = Number(yStr);
    const m = Number(mStr);
    const d = Number(dStr);
    const h = Number(hStr);
    const min = Number(minStr);
    const sec = Number(secStr || 0);
    if (![y, m, d, h, min, sec].every((n) => Number.isFinite(n))) return NaN;
    return new Date(y, m - 1, d, h, min, sec).getTime();
};

const RoomDiplomat = (props) => {
    const [actTime, setactTime] = useState("undefined");
    const [actDate, setactDate] = useState("undefined");
    const [roomName, setroomName] = useState(props.roomName);
    const [roomTime, setroomTime] = useState(props.roomTime);
    const [logoOrg, setLogoOrg] = useState(props.logoOrg);
    const [roomtext, setroomText] = useState(props.text);
    const [roomID, setroomID] = useState(props.roomId);
    const [meeting_ob, setMeeting_ob] = useState(false);
    const [deviceDescription, setDeviceDescription] = useState(null);

    const [isOn, setIsOn] = useState();
    const [needOn, setNeedOn] = useState();
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [deviceRoomGroup, setDeviceRoomGroup] = useState(null);
    const [deviceOrgId, setDeviceOrgId] = useState(null);
    const [slideshowCards, setSlideshowCards] = useState([]);
    const [slideshowIndex, setSlideshowIndex] = useState(0);
    const [slideIntervalSec, setSlideIntervalSec] = useState(15);
    const [footerLogoUrl, setFooterLogoUrl] = useState(null);
    const [footerLogoResolved, setFooterLogoResolved] = useState(false);



    const fetchStatus2 = async () => {
        let isScreenOn = false;
        let txt = "display_power=1"
        try {
            //const response = await fetch("http://localhost/cgi-bin/getScreenBacklightStatus.sh");
            const response = await fetch(`${path}/getTestVal`);
            const text = await response.text();
            console.log(text);
            //setIsOn(text.includes("display_power=1"));
            isScreenOn = text.includes("display_power=1")
            console.log("ISON:",isScreenOn)
            setIsOn(isScreenOn)
        } catch (error) {
            console.error("Chyba při načítání stavu LCD:", error);
            isScreenOn = null;
            console.log("ISON:",isScreenOn)
            setIsOn(isScreenOn);
        }
    };
    const fetchStatus = async () => {
        let isScreenOn = false;
        let txt = "display_power=1"
        try {
            const response = await fetch("http://localhost/cgi-bin/getScreenBacklightStatus.sh");
            //const response = await fetch(`${path}/getTestVal`);
            const text = await response.text();
            //console.log(text);
            //setIsOn(text.includes("display_power=1"));
            isScreenOn = text.includes("display_power=1")
            //console.log("Je zarizeni zapnute?:",isScreenOn)
            //setIsOn(isScreenOn)
            return isScreenOn;
        } catch (error) {
            console.error("Chyba při načítání stavu LCD:", error);
            isScreenOn = null;
            console.log("ISON:",isScreenOn)
            //setIsOn(isScreenOn);
            return isScreenOn;
        }
    };
    useEffect(() => {
        if (isOn !== undefined) {
            console.log("Aktuální stav obrazovky:", isOn);
        }
    }, [isOn]);

    useEffect(() => {
        const deviceId = roomID ?? props.roomId;
        if (!deviceId) return;
        const url = `${path}/getDeviceSettings/${deviceId}`;
        axios.get(url)
            .then((r) => {
                const name = r.data?.deviceDescription;
                if (name != null && String(name).trim()) setDeviceDescription(String(name).trim());
                const rg = r.data?.deviceRoomGroup;
                const parsed = (rg != null && rg !== undefined && Number.isFinite(Number(rg)) && Number(rg) >= 0) ? Math.floor(Number(rg)) : null;
                setDeviceRoomGroup(parsed);
                if (r.data?.deviceOrgId) setDeviceOrgId(r.data.deviceOrgId);
                if (typeof r.data?.settings?.slideIntervalSec === 'number') setSlideIntervalSec(Math.max(3, Math.min(300, r.data.settings.slideIntervalSec)));
            })
            .catch(() => {});
    }, [roomID, props.roomId, refreshTrigger]);

    useEffect(() => {
        const gr = deviceRoomGroup;
        const org = deviceOrgId;
        if (gr == null || Number(gr) <= 0 || !org) {
            setSlideshowCards([]);
            setSlideshowIndex(0);
            return;
        }
        let cancelled = false;
        axios.get(`${path}/getCardsV3?orgID=${org}&group=${gr}&onlyVisible=1&device_group=1`)
            .then((res) => {
                if (cancelled) return;
                const raw = Array.isArray(res.data) ? res.data : [];
                const urls = raw.filter(c => c && c.path).map(c => assetsBaseUrl + c.path);
                setSlideshowCards(urls);
                setSlideshowIndex(0);
            })
            .catch(() => { if (!cancelled) setSlideshowCards([]); });
        return () => { cancelled = true; };
    }, [deviceRoomGroup, deviceOrgId, refreshTrigger]);

    useEffect(() => {
        if (!deviceOrgId) {
            setFooterLogoUrl(null);
            setFooterLogoResolved(true);
            return;
        }
        let cancelled = false;
        setFooterLogoResolved(false);
        axios.get(`${path}/getOrganization/${deviceOrgId}`)
            .then((res) => {
                if (cancelled) return;
                const logoPath = Array.isArray(res.data) && res.data[0]?.logoPath ? String(res.data[0].logoPath) : null;
                setFooterLogoUrl(logoPath ? `${assetsBaseUrl}${logoPath}?t=${Date.now()}` : null);
                setFooterLogoResolved(true);
            })
            .catch(() => {
                if (!cancelled) {
                    setFooterLogoUrl(null);
                    setFooterLogoResolved(true);
                }
            });
        return () => { cancelled = true; };
    }, [deviceOrgId, refreshTrigger]);

    useEffect(() => {
        if (slideshowCards.length <= 1) return;
        const intervalMs = Math.max(3000, (slideIntervalSec || 15) * 1000);
        const id = setInterval(() => setSlideshowIndex((prev) => (prev + 1) % slideshowCards.length), intervalMs);
        return () => clearInterval(id);
    }, [slideshowCards.length, slideIntervalSec]);

    const toggleScreen = async (needToBeOn,isDevicePowerOn) => {
        if (isDevicePowerOn === undefined || isDevicePowerOn === null) {
            console.log("Stav obrazovky zatím neznámý.");
            return;
        }
        console.log({
            needToBeOn: needToBeOn,
            isOn: isDevicePowerOn
        })
        if (needToBeOn != isDevicePowerOn ){
            console.log(` Nsrovnalost - NeedOn:${needToBeOn} / IsOn:${isDevicePowerOn}`)
            try {
                await fetch(`http://localhost/cgi-bin/${needToBeOn ? "setScreenBacklightOn.sh" : "setScreenBacklightOff.sh"}`);
                setIsOn(needToBeOn);
            } catch (error) {
                console.error("Chyba při změně stavu LCD:", error);
            }
        }else console.log("Vstupy souhlasí: ",needToBeOn,isDevicePowerOn)

    };



    // const actTime = `${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`;
    //const actDate = `${String(dt.getDate()).padStart(2, "0")}. ${String(dt.getMonth() + 1).padStart(2, "0")}. ${dt.getFullYear()}`;
    const getTime = () => {
        const now = new Date();

        // Získání jednotlivých částí data
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Měsíce jsou indexovány od 0
        const day = String(now.getDate()).padStart(2, '0');

        // Získání jednotlivých částí času
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        // Sestavení výsledného řetězce
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }

    useEffect(() => {
        // Funkce, která se spustí každou minutu

        const hourDelay =60 *  15 * 1000; // 1 hour in milliseconds
       // const refreshPage = setTimeout(() => {
       //     window.location.reload();
        //}, hourDelay);

        const resetVal = async (org) => {
            try {
                await axios.post(`${path}/updateReset/${roomID}`, org ? { orgID: org } : {});
            } catch (_) {}
        };
        const getReset = async () => {
            try {
                const orgParam = deviceOrgId ? `?orgID=${encodeURIComponent(deviceOrgId)}` : '';
                const response = await axios.get(`${path}/getReset/${roomID}${orgParam}`);
                const need = response.data?.[0]?.needUpdate;
                if (need === 1 || need === true) {
                    console.log("[RoomDiplomat] Změna nastavení – obnovuji data bez reloadu");
                    await resetVal(deviceOrgId);
                    setRefreshTrigger((t) => t + 1);
                }
            } catch (error) {
                // ignore
            }
        };


        const send = async () =>{
            let needToBeOn, isDevicePowerOn;
            try {
                const response = await axios.get(`${path}/getMeeting/${roomID}/${encodeURIComponent(getTime())}`);
                const data = Array.isArray(response.data) ? response.data : [];
                if (data.length > 0) {
                    const rec = data[0];
                    setNeedOn(true);
                    needToBeOn = true;
                    setroomText(rec.description ?? '');
                    setLogoOrg(rec.path ? (assetsBaseUrl + rec.path) : null);
                    // Použij čas tak, jak je uložen v DB (bez timezone konverze)
                    setroomTime(rec.dateFrom && rec.dateTo ? `${String(rec.dateFrom).substring(11, 16)} - ${String(rec.dateTo).substring(11, 16)}` : null);
                } else {
                    needToBeOn = false;
                    setroomTime(null);
                    setLogoOrg(null);
                    setroomText(null);
                    setNeedOn(false);
                }
            }
            catch (error) {
                setLogoOrg(null);
                setroomText(null);
                setroomTime(null);
                setNeedOn(false);
                needToBeOn = false;
            }
            isDevicePowerOn = await fetchStatus();
            console.error(isDevicePowerOn)
            //await fetchStatus()
            await toggleScreen(needToBeOn,isDevicePowerOn)
        }


        const updateMinute = () => {
            let dt = new Date
            //console.log(dt)
            setactTime(`${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`)
            setactDate(`${String(dt.getDate()).padStart(2, "0")}. ${String(dt.getMonth() + 1).padStart(2, "0")}. ${dt.getFullYear()}`)
        };
        updateMinute()
        // Nastavení intervalu na 60 000 ms (1 minuta)
        const intervalId = setInterval(updateMinute, 1000);
        const intervalId2 = setInterval(send, 60 *  1000);
        getReset();
        const intervalId3 = setInterval(getReset, 3 * 1000); // každé 3 s
        const onVisibility = () => {
            if (typeof document !== 'undefined' && document.visibilityState === 'visible') getReset();
        };
        document.addEventListener('visibilitychange', onVisibility);
        return () => {
            clearInterval(intervalId);
            clearInterval(intervalId2);
            clearInterval(intervalId3);
            document.removeEventListener('visibilitychange', onVisibility);
        };
    }, [refreshTrigger, roomID, deviceOrgId]);
    useEffect(() => {
        fetchStatus();
    }, []);
    const rawName = deviceDescription ?? roomName;
    const roomDisplayName = (rawName != null && String(rawName).trim() && String(rawName).toLowerCase() !== 'undefined')
        ? String(rawName).trim()
        : (roomID ? `Místnost ${roomID}` : '—');

    useEffect(() => {
        if (typeof document !== 'undefined' && roomDisplayName) {
            document.title = roomDisplayName;
        }
    }, [roomDisplayName]);

    const slideshowUrl = slideshowCards.length > 0 ? slideshowCards[slideshowIndex % slideshowCards.length] : null;
    const footerLogoSrc = footerLogoResolved ? (footerLogoUrl || logo) : null;
    let slideshowView = slideshowCards.length > 0 && slideshowUrl ? (
        <div className={classes.mainNo}>
            <img src={slideshowUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        </div>
    ) : null;
    let noMeeting = (
        <div className={classes.noMeetingModern}>
            <header className={classes.noMeetingModern_header}>
                <h1 className={classes.noMeetingModern_roomName}>{roomDisplayName}</h1>
            </header>
            <div className={classes.noMeetingModern_body} />
            <footer className={classes.noMeetingModern_footer}>
                <div className={classes.noMeetingModern_logoWrap}>
                    {footerLogoSrc && <img src={footerLogoSrc} alt="" />}
                </div>
            </footer>
        </div>
    );
    let meeting = (<div className={classes.main}>
        <div className={classes.header}>
            {roomName}
        </div>
        <div className={classes.body}>
            <label>{roomtext}</label>
            <label>{roomTime}</label>
            {logoOrg && <img src={logoOrg} alt={"logo"}/>}
        </div>
        <div className={classes.footer}>
            <div className={classes.line}>
                <div className={classes.lineL}></div>
            </div>
            <div className={classes.logo}>
                {footerLogoSrc && <img src={footerLogoSrc} alt={"logo"}/>}
            </div>
            <div className={classes.lineB}>
                <div className={classes.lineL}></div>
            </div>
        </div>
    </div>)


    if (roomtext != null && roomtext !== '') return <>{meeting}</>;
    if (slideshowView) return <>{slideshowView}</>;
    return <>{noMeeting}</>;
}
export default RoomDiplomat